export default class CreateResultadoPersonalC3 {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(idPersonal, resultado) {
    return await this.#repository.create(idPersonal, resultado)
  }
}
